import React, { memo } from 'react';

import cx from 'classnames';
import { ChartComponent, ChartNoInfo, Preloader, TableWithPagination } from '../..';
import { FullscreenButton } from '../../Charts/ChartFullscreen/FullscreenButton';
import FullscreenProvider from '../../Charts/ChartFullscreen/FullscreenContext';

import { miniGraphicTable } from '../../../constants/graphics.constants';

import { createMonitoringRows } from '../../../utils/chartHelper';
import { getChartData, getChartOptions, getNetworkOptions } from './utils';

import '../MonitoringGraphic.scss';

export const ServerGraphic = memo(
  ({
    data,
    chartMetric = '%',
    chartArea,
    title = false,
    allMetric = false,
    dates,
    colorIndex,
    table = false,
    network = false,
    large = false,
    percentMaxValue = false,
    showTooltipUnits = false,
    getChartOptions: getCustomCHartOptions,
    getTooltipValue,
  }) => {
    const makeChartOptions = () => {
      if (network) {
        return getNetworkOptions(data, dates, colorIndex, chartMetric);
      } else if (getCustomCHartOptions) {
        return getCustomCHartOptions();
      }
      
      return getChartOptions(
        data,
        dates,
        colorIndex,
        allMetric,
        chartMetric,
        chartArea,
        percentMaxValue,
      );
    };
    
    return (
      <div className={cx('monitoring-graphic', { 'mini-graphic': !network && !large })}>
        <FullscreenProvider>
          {title && (
            <div className="monitoring-graphic__title d-flex align-items-center justify-content-between">
              {title}
              <FullscreenButton />
            </div>
          )}
          {(data === null || data.length === 0) && <ChartNoInfo />}
          {data !== null && data.length !== 0 && !data[0].values && (
            <div className="graphic-no-data--info graphic-no-data--info--without-border">
              <Preloader big={true} />
            </div>
          )}
          {data !== null && data.length !== 0 && data[0].values !== null && (
            <ChartComponent
              chartType={data.length !== 1 && !network ? 'LineChart' : 'AreaChart'}
              content={getChartData(data, dates, chartMetric, network, showTooltipUnits, getTooltipValue)}
              chartOptions={makeChartOptions()}
            />
          )}
        </FullscreenProvider>
        {data !== null && data.length !== 0 && data[0].values !== null && table && (
          <TableWithPagination
            headerOptions={miniGraphicTable}
            rows={createMonitoringRows(data !== null ? data : [])}
          />
        )}
      </div>
    );
  }
);
